import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Deposit from '@/components/Deposit'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/deposit',
      name: 'Deposit',
      component: Deposit
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js